import { memo } from 'react';
import { useAtomValue } from 'jotai';
import { isEmailTokenSentModalOpen } from '../../context/auth-flow';
import { LoginLinkSentForm } from './login-link-sent-form';

export const LoginLinkSentModal = memo(() => {
  const open = useAtomValue(isEmailTokenSentModalOpen);

  if (!open) return null;

  // The form owns the full layout (fixed header + scrollable body + fixed
  // footer), so it never overflows the viewport. See the note in the DS about
  // DesktopModal's vw-based height cap.
  return <LoginLinkSentForm isModal />;
});
